import { render, staticRenderFns } from "./userManagePage.vue?vue&type=template&id=565ecfc8&scoped=true"
import script from "./userManagePage.vue?vue&type=script&lang=js"
export * from "./userManagePage.vue?vue&type=script&lang=js"
import style0 from "./userManagePage.vue?vue&type=style&index=0&id=565ecfc8&prod&scoped=true&lang=less"
import style1 from "./userManagePage.vue?vue&type=style&index=1&id=565ecfc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ecfc8",
  null
  
)

export default component.exports